import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  X, CheckCircle, MapPin, Building, Shield, Zap, Wifi, Wind, Car, Eye,
  Lock, Server, Phone, ChevronRight,
} from 'lucide-react';
import cover from '../images/projects/citadel7_cover.png';

/* =========================================================
   🔍 SEO CONSTANTS
   ========================================================= */
const SITE_URL = 'https://www.estateghar.com'; // ⚠️ change to your real domain
const SITE_NAME = 'EstateGhar';
const CANONICAL_PATH = '/projects/citadel7';
const CANONICAL_URL = `${SITE_URL}${CANONICAL_PATH}`;

const PROJECT_NAME = 'Citadel 7';
const PROJECT_TAGLINE = "Pakistan's First Smart Tech Tower";
const PROJECT_CITY = 'Islamabad';
const PROJECT_LOCATION = 'Main Blue Area, Islamabad';
const PROJECT_DEVELOPER = 'Chakor Ventures';
const WHATSAPP_URL = 'https://wa.me/923487172565';

const PAGE_TITLE =
  "Citadel 7 Islamabad | Pakistan's First Smart Tech Tower in Blue Area";
const PAGE_DESCRIPTION =
  "Citadel 7 — Pakistan's first smart tech tower in Main Blue Area, Islamabad by Chakor Ventures. Premium corporate offices, AI-powered BMS, zero power downtime, FTTO fiber, 4-level basement parking & EV charging. Flexible installment plans. Book your office today.";

const Citadel7 = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Data extracted from PDFs
  const floorPlans = [
    {
      floor: '7th - 10th Floors',
      offices: [
        { num: '701', area: 1244, price: 14500, total: '142,438,000', booking: '85,462,800', install: '21,365,700' },
        { num: '702', area: 684, price: 114500, total: '78,318,000', booking: '46,990,800', install: '11,747,700' },
        { num: '703', area: 684, price: 114500, total: '78,318,000', booking: '46,990,800', install: '11,747,700' },
        { num: '704', area: 1849, price: 114500, total: '211,710,500', booking: '127,026,300', install: '31,756,575' },
        { num: '705', area: 867, price: 110000, total: '95,370,000', booking: '57,222,000', install: '14,305,500' },
        { num: '706', area: 885, price: 100700, total: '89,119,500', booking: '53,471,700', install: '13,367,925' },
        { num: '707', area: 1205, price: 104500, total: '125,922,500', booking: '75,553,500', install: '18,888,375' },
        { num: '708', area: 630, price: 104500, total: '65,835,000', booking: '39,501,000', install: '9,875,250' },
        { num: '709', area: 630, price: 104500, total: '65,835,000', booking: '39,501,000', install: '9,875,250' },
        { num: '710', area: 1222, price: 104500, total: '127,699,000', booking: '76,619,400', install: '19,154,850' },
        { num: '711', area: 495, price: 100000, total: '49,500,000', booking: '29,700,000', install: '7,425,000' },
        { num: '712', area: 495, price: 100000, total: '49,500,000', booking: '29,700,000', install: '7,425,000' },
        { num: '713', area: 471, price: 100000, total: '47,100,000', booking: '28,260,000', install: '7,065,000' },
      ],
    },
    {
      floor: '11th - 13th Floors',
      offices: [
        { num: '1101', area: 1244, price: 117000, total: '145,548,000', booking: '87,328,800', install: '21,832,200' },
        { num: '1102', area: 684, price: 117000, total: '80,028,000', booking: '48,016,800', install: '12,004,200' },
        { num: '1103', area: 684, price: 117000, total: '80,028,000', booking: '48,016,800', install: '12,004,200' },
        { num: '1104', area: 1849, price: 117000, total: '216,333,000', booking: '129,799,800', install: '32,449,950' },
        { num: '1105', area: 867, price: 113000, total: '97,971,000', booking: '58,782,600', install: '14,695,650' },
        { num: '1106', area: 885, price: 103500, total: '91,597,500', booking: '54,958,500', install: '13,739,625' },
        { num: '1107', area: 1205, price: 107000, total: '128,935,000', booking: '77,361,000', install: '19,340,250' },
        { num: '1108', area: 630, price: 107000, total: '67,410,000', booking: '40,446,000', install: '10,111,500' },
        { num: '1109', area: 630, price: 107000, total: '67,410,000', booking: '40,446,000', install: '10,111,500' },
        { num: '1110', area: 1222, price: 107000, total: '130,754,000', booking: '78,452,400', install: '19,613,100' },
      ],
    },
    {
      floor: '14th - 18th Floors',
      offices: [
        { num: '1401', area: 1244, price: 119000, total: '148,036,000', booking: '88,821,600', install: '22,205,400' },
        { num: '1402', area: 684, price: 119000, total: '81,396,000', booking: '48,837,600', install: '12,209,400' },
        { num: '1403', area: 684, price: 119000, total: '81,396,000', booking: '48,837,600', install: '12,209,400' },
        { num: '1404', area: 1849, price: 119000, total: '220,031,000', booking: '132,018,600', install: '33,004,650' },
        { num: '1405', area: 867, price: 115000, total: '99,705,000', booking: '59,823,000', install: '14,955,750' },
        { num: '1406', area: 885, price: 107000, total: '94,695,000', booking: '56,817,000', install: '14,204,250' },
        { num: '1407', area: 1205, price: 111000, total: '133,755,000', booking: '80,253,000', install: '20,063,250' },
        { num: '1408', area: 630, price: 111000, total: '69,930,000', booking: '41,958,000', install: '10,489,500' },
        { num: '1409', area: 630, price: 111000, total: '69,930,000', booking: '41,958,000', install: '10,489,500' },
        { num: '1410', area: 1222, price: 111000, total: '135,642,000', booking: '81,385,200', install: '20,346,300' },
      ],
    },
    {
      floor: '19th - 20th Floors',
      offices: [
        { num: '1901', area: 1244, price: 122000, total: '151,768,000', booking: '91,060,800', install: '22,765,200' },
        { num: '1902', area: 684, price: 122000, total: '83,448,000', booking: '50,068,800', install: '12,517,200' },
        { num: '1903', area: 684, price: 122000, total: '83,448,000', booking: '50,068,800', install: '12,517,200' },
        { num: '1904', area: 1849, price: 122000, total: '225,578,000', booking: '135,346,800', install: '33,836,700' },
        { num: '1905', area: 867, price: 118000, total: '102,306,000', booking: '61,383,600', install: '15,345,900' },
        { num: '1906', area: 885, price: 109500, total: '96,907,500', booking: '58,144,500', install: '14,536,125' },
        { num: '1907', area: 1205, price: 113000, total: '136,165,000', booking: '81,699,000', install: '20,424,750' },
        { num: '1908', area: 630, price: 113000, total: '71,190,000', booking: '42,714,000', install: '10,678,500' },
        { num: '1909', area: 630, price: 113000, total: '71,190,000', booking: '42,714,000', install: '10,678,500' },
        { num: '1910', area: 1222, price: 113000, total: '138,086,000', booking: '82,851,600', install: '20,712,900' },
      ],
    },
  ];

  /* =========================================================
     🔍 SEO: JSON-LD @graph
     ========================================================= */
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'RealEstateListing',
        '@id': `${CANONICAL_URL}#listing`,
        name: `${PROJECT_NAME} — ${PROJECT_TAGLINE}`,
        description: PAGE_DESCRIPTION,
        url: CANONICAL_URL,
        image: `${SITE_URL}/images/projects/citadel7-cover.jpg`,
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Main Blue Area, Jinnah Avenue',
          addressLocality: PROJECT_CITY,
          addressRegion: 'Islamabad Capital Territory',
          postalCode: '44000',
          addressCountry: 'PK',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: '33.7155',
          longitude: '73.0700',
        },
        provider: {
          '@type': 'Organization',
          name: PROJECT_DEVELOPER,
        },
        offers: {
          '@type': 'AggregateOffer',
          priceCurrency: 'PKR',
          lowPrice: '47100000',
          highPrice: '225578000',
          offerCount: floorPlans.reduce((n, f) => n + f.offices.length, 0),
          availability: 'https://schema.org/PreOrder',
          url: CANONICAL_URL,
        },
        amenityFeature: [
          'Zero Power Downtime',
          'FTTO Fiber System',
          'AI-Powered BMS',
          '24/7 Power Backup',
          'Fire Fighting System',
          'Smart VRF & HVAC',
          '4-Level Basement Parking',
          'EV Charging',
          'Starlink Ready',
          'High-Speed Elevators',
        ],
      },
      {
        '@type': 'Organization',
        '@id': `${SITE_URL}/#organization`,
        name: SITE_NAME,
        url: SITE_URL,
        logo: `${SITE_URL}/logo.png`,
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+92-348-7172565',
          contactType: 'sales',
          areaServed: 'PK',
          availableLanguage: ['English', 'Urdu'],
        },
      },
      {
        '@type': 'BreadcrumbList',
        '@id': `${CANONICAL_URL}#breadcrumb`,
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
          { '@type': 'ListItem', position: 2, name: 'Projects', item: `${SITE_URL}/projects` },
          { '@type': 'ListItem', position: 3, name: PROJECT_NAME, item: CANONICAL_URL },
        ],
      },
      {
        '@type': 'FAQPage',
        '@id': `${CANONICAL_URL}#faq`,
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Where is Citadel 7 located in Islamabad?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Citadel 7 is located in Main Blue Area, Islamabad — directly opposite Centaurus Mall and PIMS Hospital, with direct entrances from Jinnah Avenue and Ibn-e-Sina Road.',
            },
          },
          {
            '@type': 'Question',
            name: "What is Citadel 7's office price range?",
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Citadel 7 office prices start from PKR 47.1 million for a 471 sqft unit on the 7th floor and go up to PKR 225.6 million for a 1849 sqft corner office on higher floors. Flexible installment plans are available.',
            },
          },
          {
            '@type': 'Question',
            name: 'What makes Citadel 7 a smart tech tower?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Citadel 7 features an AI-powered BMS, FTTO fiber-optic connectivity from multiple ISPs, zero-power-downtime UPS and generators, Starlink-ready infrastructure, smart VRF/HVAC systems, D.C.S. AI-optimized elevator routing, and advanced cybersecurity.',
            },
          },
          {
            '@type': 'Question',
            name: 'What amenities does Citadel 7 offer?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Citadel 7 offers 24/7 power backup, multi-provider fiber internet, NFPA-compliant fire fighting, smart VRF HVAC, 4-level basement parking with EV charging, high-performance UV-controlled facade, 70-person elevators, and fire-rated doors with smoke sensors.',
            },
          },
          {
            '@type': 'Question',
            name: 'Who is the developer of Citadel 7?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Citadel 7 is developed by Chakor Ventures, an emerging high-rise real estate developer in Pakistan focused on smart, future-ready commercial and residential projects.',
            },
          },
        ],
      },
    ],
  };

  return (
    <div className="min-h-screen bg-[#0A1A3A] text-white font-sans selection:bg-cyan-500 selection:text-white">
      {/* =========================================================
          🔍 SEO: Helmet head
          ========================================================= */}
      <Helmet>
        <html lang="en-PK" />
        <title>{PAGE_TITLE}</title>
        <meta name="title" content={PAGE_TITLE} />
        <meta name="description" content={PAGE_DESCRIPTION} />
        <meta
          name="keywords"
          content="Citadel 7, Citadel 7 Islamabad, Chakor Ventures, smart tech tower Islamabad, Blue Area offices, corporate offices Islamabad, office for sale Islamabad, commercial property Blue Area, smart building Pakistan, AI powered building Islamabad, FTTO office Islamabad, office space investment Islamabad, Citadel 7 payment plan, Citadel 7 price"
        />
        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1"
        />
        <meta name="author" content={PROJECT_DEVELOPER} />
        <meta name="theme-color" content="#0A1A3A" />
        <link rel="canonical" href={CANONICAL_URL} />

        {/* Geo signals */}
        <meta name="geo.region" content="PK-IS" />
        <meta name="geo.placename" content={PROJECT_CITY} />
        <meta name="geo.position" content="33.7155;73.0700" />
        <meta name="ICBM" content="33.7155, 73.0700" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta property="og:url" content={CANONICAL_URL} />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:locale" content="en_PK" />
        <meta
          property="og:image"
          content={`${SITE_URL}/images/projects/citadel7-cover.jpg`}
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content={`${PROJECT_NAME} — ${PROJECT_TAGLINE} in ${PROJECT_CITY}`}
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={CANONICAL_URL} />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESCRIPTION} />
        <meta
          name="twitter:image"
          content={`${SITE_URL}/images/projects/citadel7-cover.jpg`}
        />

        {/* hreflang */}
        <link rel="alternate" hrefLang="en-PK" href={CANONICAL_URL} />
        <link rel="alternate" hrefLang="x-default" href={CANONICAL_URL} />

        {/* JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {/* Navigation */}
      <nav
        className="fixed top-0 w-full z-50 bg-[#0A1A3A]/90 backdrop-blur-md border-b border-cyan-500/30"
        aria-label="Primary"
      >
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="text-2xl font-bold tracking-wider text-white">
            CHAKOR<span className="text-cyan-400"> VENTURES</span>
          </div>
          <div className="hidden md:flex space-x-8 text-sm font-medium text-gray-300">
            <a href="#about" className="hover:text-cyan-400 transition">About</a>
            <a href="#location" className="hover:text-cyan-400 transition">Location</a>
            <a href="#amenities" className="hover:text-cyan-400 transition">Amenities</a>
            <a href="#payment-plan" className="hover:text-cyan-400 transition">Payment Plan</a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-cyan-500 hover:bg-cyan-400 text-[#0A1A3A] px-4 py-2 rounded-full font-bold transition"
            >
              Contact Us
            </a>
          </div>
        </div>
      </nav>

      <main>
        {/* Hero Section */}
        <header className="relative h-screen flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop"
              alt={`${PROJECT_NAME} modern skyline at Main Blue Area, Islamabad`}
              className="w-full h-full object-cover"
              loading="eager"
              fetchPriority="high"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#0A1A3A]/80 via-[#0A1A3A]/60 to-[#0A1A3A]"></div>
          </div>

          <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
            <div className="mb-6 flex justify-center items-center space-x-2 text-cyan-400 font-semibold tracking-widest text-sm uppercase">
              <span className="w-8 h-[2px] bg-cyan-400"></span>
              <span>{PROJECT_TAGLINE}</span>
              <span className="w-8 h-[2px] bg-cyan-400"></span>
            </div>
            {/* 🔍 SEO: single H1 with primary keyword */}
            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
              CITADEL <span className="text-cyan-400">7</span>
              <span className="block text-2xl md:text-3xl font-normal text-gray-300 mt-3">
                Corporate Offices in Main Blue Area, Islamabad
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-2xl mx-auto">
              A smart, connected, and future-ready corporate landmark in the heart of Islamabad.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-cyan-500 hover:bg-cyan-400 text-[#0A1A3A] px-8 py-4 rounded-full font-bold text-lg transition transform hover:scale-105 shadow-[0_0_20px_rgba(6,182,212,0.5)] flex items-center justify-center gap-2"
                aria-label="Contact Chakor Ventures on WhatsApp about Citadel 7"
              >
                <Phone size={20} aria-hidden="true" />
                Contact on WhatsApp
              </a>
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-transparent border-2 border-cyan-500 text-cyan-400 hover:bg-cyan-500/10 px-8 py-4 rounded-full font-bold text-lg transition transform hover:scale-105 flex items-center justify-center gap-2"
                aria-label="View Citadel 7 payment plan"
              >
                <Building size={20} aria-hidden="true" />
                View Payment Plan
              </button>
            </div>
          </div>
        </header>

        {/* About Section */}
        <section id="about" className="py-24 bg-[#0A1A3A]" aria-labelledby="about-heading">
          <div className="container mx-auto px-6">
            <div className="flex flex-col md:flex-row items-center gap-16">
              <div className="md:w-1/2">
                <h2 id="about-heading" className="text-4xl font-bold mb-6">
                  Who <span className="text-cyan-400">We Are</span>
                </h2>
                <p className="text-gray-400 leading-relaxed mb-6">
                  Chakor Ventures is an emerging high-rise real estate developer that is
                  changing the urban landscape of Pakistan. We aim to create world-class
                  commercial and residential spaces using our extensive expertise,
                  cutting-edge technology, and quality resources.
                </p>
                <p className="text-gray-400 leading-relaxed mb-8">
                  The company's vision is to develop state-of-the-art industry-leading
                  projects while empowering communities and promoting economic growth.
                </p>
                <div className="grid grid-cols-2 gap-6">
                  <div className="flex items-center gap-3">
                    <CheckCircle className="text-cyan-400" size={24} aria-hidden="true" />
                    <span className="font-semibold">Zero Dead Spot</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <CheckCircle className="text-cyan-400" size={24} aria-hidden="true" />
                    <span className="font-semibold">FTTO System</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <CheckCircle className="text-cyan-400" size={24} aria-hidden="true" />
                    <span className="font-semibold">Zero Power Downtime</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <CheckCircle className="text-cyan-400" size={24} aria-hidden="true" />
                    <span className="font-semibold">AI Powered</span>
                  </div>
                </div>
              </div>
              <div className="md:w-1/2 relative">
                <div className="absolute -inset-4 bg-cyan-500/20 rounded-xl blur-xl"></div>
                <img
                  src={cover}
                  alt="Modern architecture at Citadel 7, Islamabad"
                  className="relative rounded-xl shadow-2xl border border-cyan-500/30"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Location Section */}
        <section id="location" className="py-24 bg-[#0d224a]" aria-labelledby="location-heading">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 id="location-heading" className="text-4xl font-bold mb-4">
                Prime <span className="text-cyan-400">Location</span>
              </h2>
              <p className="text-gray-400 max-w-2xl mx-auto">
                Main Blue Area, Islamabad. Strategically connected to everything that matters.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-[#0A1A3A] p-8 rounded-xl border border-cyan-500/20 hover:border-cyan-500/50 transition">
                <MapPin className="text-cyan-400 mb-4" size={32} aria-hidden="true" />
                <h3 className="text-xl font-bold mb-4">Nearby Landmarks</h3>
                <ul className="space-y-3 text-gray-400">
                  <li className="flex justify-between"><span>Centaurus Mall</span> <span className="text-cyan-400">Right Opposite</span></li>
                  <li className="flex justify-between"><span>PIMS Hospital</span> <span className="text-cyan-400">Directly Opposite</span></li>
                  <li className="flex justify-between"><span>Kulsoom Hospital</span> <span className="text-cyan-400">3 Minutes</span></li>
                  <li className="flex justify-between"><span>Faisal Mosque</span> <span className="text-cyan-400">5 Minutes</span></li>
                  <li className="flex justify-between"><span>National Assembly</span> <span className="text-cyan-400">5 Minutes</span></li>
                  <li className="flex justify-between"><span>Supreme Court</span> <span className="text-cyan-400">5 Minutes</span></li>
                  <li className="flex justify-between"><span>Marriott Hotel</span> <span className="text-cyan-400">5 Minutes</span></li>
                  <li className="flex justify-between"><span>Islamabad Airport</span> <span className="text-cyan-400">27 Minutes</span></li>
                </ul>
              </div>

              <div className="bg-[#0A1A3A] p-8 rounded-xl border border-cyan-500/20 hover:border-cyan-500/50 transition">
                <Car className="text-cyan-400 mb-4" size={32} aria-hidden="true" />
                <h3 className="text-xl font-bold mb-4">Accessibility</h3>
                <ul className="space-y-3 text-gray-400">
                  <li className="flex justify-between"><span>Expressway</span> <span className="text-cyan-400">1 Minute</span></li>
                  <li className="flex justify-between"><span>9th Avenue</span> <span className="text-cyan-400">1 Minute</span></li>
                  <li className="flex justify-between"><span>7th Avenue</span> <span className="text-cyan-400">2 Minutes</span></li>
                  <li className="flex justify-between"><span>Margalla Road</span> <span className="text-cyan-400">3 Minutes</span></li>
                  <li className="flex justify-between"><span>Srinagar Highway</span> <span className="text-cyan-400">3 Minutes</span></li>
                </ul>
                <h3 className="text-xl font-bold mt-6 mb-4">Metro Stations</h3>
                <ul className="space-y-3 text-gray-400">
                  <li className="flex justify-between"><span>Red Line</span> <span className="text-cyan-400">Walking Distance</span></li>
                  <li className="flex justify-between"><span>Green Line</span> <span className="text-cyan-400">Walking Distance</span></li>
                  <li className="flex justify-between"><span>Blue Line</span> <span className="text-cyan-400">Walking Distance</span></li>
                  <li className="flex justify-between"><span>Orange Line</span> <span className="text-cyan-400">2 Minutes</span></li>
                </ul>
              </div>

              <div className="bg-[#0A1A3A] p-8 rounded-xl border border-cyan-500/20 hover:border-cyan-500/50 transition">
                <Building className="text-cyan-400 mb-4" size={32} aria-hidden="true" />
                <h3 className="text-xl font-bold mb-4">Direct Entrances</h3>
                <ul className="space-y-3 text-gray-400">
                  <li>Jinnah Avenue</li>
                  <li>Ibn-e-Sina Road</li>
                </ul>
                <div className="mt-6 p-4 bg-cyan-500/10 rounded-lg border border-cyan-500/30">
                  <p className="text-sm text-cyan-300">
                    Strategic connectivity pathway ensuring seamless access to the city's arterial roads.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Amenities Section */}
        <section id="amenities" className="py-24 bg-[#0A1A3A]" aria-labelledby="amenities-heading">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h2 id="amenities-heading" className="text-4xl font-bold mb-4">
                World-Class <span className="text-cyan-400">Amenities</span>
              </h2>
              <p className="text-gray-400 max-w-2xl mx-auto">
                Experience the future of corporate living with our state-of-the-art facilities.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { icon: <Zap size={28} />, title: '24/7 Power Backup', desc: 'Generators & UPS for zero downtime.' },
                { icon: <Wifi size={28} />, title: 'Multi Internet Providers', desc: 'Fiber-optic connections from leading ISPs.' },
                { icon: <Shield size={28} />, title: 'Fire Fighting System', desc: 'NFPA compliant, UL-listed equipment.' },
                { icon: <Wind size={28} />, title: 'Smart VRF & HVAC', desc: 'Office-wise control & energy efficient.' },
                { icon: <Car size={28} />, title: '4-Level Basement Parking', desc: '200+ vehicles capacity with EV charging.' },
                { icon: <Eye size={28} />, title: 'High Performance Facade', desc: 'UV controlled, noise reduction, energy saving.' },
                { icon: <Lock size={28} />, title: 'Tech Secure Business', desc: 'Advanced cybersecurity & smart tech.' },
                { icon: <Server size={28} />, title: 'Starlink Ready Tower', desc: 'High-speed, low-latency satellite internet.' },
              ].map((item, index) => (
                <div
                  key={index}
                  className="bg-[#0d224a] p-6 rounded-xl border border-cyan-500/10 hover:border-cyan-500/40 transition group"
                >
                  <div className="text-cyan-400 mb-4 group-hover:scale-110 transition-transform" aria-hidden="true">
                    {item.icon}
                  </div>
                  <h3 className="text-lg font-bold mb-2">{item.title}</h3>
                  <p className="text-sm text-gray-400">{item.desc}</p>
                </div>
              ))}
            </div>

            {/* Additional Amenities */}
            <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-gradient-to-br from-[#0d224a] to-[#0A1A3A] p-8 rounded-xl border border-cyan-500/20">
                <h3 className="text-2xl font-bold mb-4 text-cyan-400">BMS System</h3>
                <ul className="space-y-3 text-gray-300">
                  <li className="flex items-start gap-2"><CheckCircle size={18} className="text-cyan-400 mt-1 shrink-0" aria-hidden="true" /> Advanced W-LAN System (FTTO)</li>
                  <li className="flex items-start gap-2"><CheckCircle size={18} className="text-cyan-400 mt-1 shrink-0" aria-hidden="true" /> GPON Announcement System</li>
                  <li className="flex items-start gap-2"><CheckCircle size={18} className="text-cyan-400 mt-1 shrink-0" aria-hidden="true" /> PBAX Intercom Connectivity</li>
                  <li className="flex items-start gap-2"><CheckCircle size={18} className="text-cyan-400 mt-1 shrink-0" aria-hidden="true" /> Future-Proof Infrastructure</li>
                </ul>
              </div>
              <div className="bg-gradient-to-br from-[#0d224a] to-[#0A1A3A] p-8 rounded-xl border border-cyan-500/20">
                <h3 className="text-2xl font-bold mb-4 text-cyan-400">Elevators & Safety</h3>
                <ul className="space-y-3 text-gray-300">
                  <li className="flex items-start gap-2"><CheckCircle size={18} className="text-cyan-400 mt-1 shrink-0" aria-hidden="true" /> 70 Persons Capacity Elevators</li>
                  <li className="flex items-start gap-2"><CheckCircle size={18} className="text-cyan-400 mt-1 shrink-0" aria-hidden="true" /> D.C.S. AI Enabled Optimized Routing</li>
                  <li className="flex items-start gap-2"><CheckCircle size={18} className="text-cyan-400 mt-1 shrink-0" aria-hidden="true" /> Firefighting Equipped Elevators</li>
                  <li className="flex items-start gap-2"><CheckCircle size={18} className="text-cyan-400 mt-1 shrink-0" aria-hidden="true" /> Fire-Rated Doors & Smoke Sensors</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Payment Plan CTA */}
        <section
          id="payment-plan"
          className="py-24 bg-[#0d224a] relative overflow-hidden"
          aria-labelledby="payment-plan-heading"
        >
          <div className="absolute top-0 right-0 w-1/2 h-full bg-cyan-500/5 blur-[100px] rounded-full"></div>
          <div className="container mx-auto px-6 relative z-10 text-center">
            <h2 id="payment-plan-heading" className="text-4xl font-bold mb-6">
              Investment <span className="text-cyan-400">Opportunity</span>
            </h2>
            <p className="text-gray-400 max-w-2xl mx-auto mb-10">
              Secure your office space in Pakistan's first smart tech tower. Flexible
              payment plans available with easy installments.
            </p>
            <button
              onClick={() => setIsModalOpen(true)}
              className="bg-cyan-500 hover:bg-cyan-400 text-[#0A1A3A] px-10 py-5 rounded-full font-bold text-xl transition transform hover:scale-105 shadow-[0_0_30px_rgba(6,182,212,0.4)] inline-flex items-center gap-3"
              aria-label="View detailed Citadel 7 payment plan"
            >
              View Detailed Payment Plan
              <ChevronRight size={24} aria-hidden="true" />
            </button>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#0A1A3A] py-12 border-t border-cyan-500/20">
        <div className="container mx-auto px-6 text-center">
          <div className="text-2xl font-bold tracking-wider text-white mb-4">
            CHAKOR<span className="text-cyan-400"> VENTURES</span>
          </div>
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Chakor Ventures. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mt-2">
            Presented by{' '}
            <a
              href={SITE_URL}
              className="text-cyan-400 hover:text-cyan-300 underline"
            >
              {SITE_NAME}
            </a>
          </p>
        </div>
      </footer>

      {/* Payment Plan Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
          role="dialog"
          aria-modal="true"
          aria-labelledby="payment-modal-title"
        >
          <div className="bg-[#0A1A3A] border border-cyan-500/30 rounded-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col shadow-2xl shadow-cyan-500/20">
            <div className="flex justify-between items-center p-6 border-b border-cyan-500/20 bg-[#0d224a]">
              <div>
                <h3 id="payment-modal-title" className="text-2xl font-bold text-white">
                  Payment Plan
                </h3>
                <p className="text-cyan-400 text-sm">
                  Citadel 7 — Pakistan's First Smart Tech Tower
                </p>
              </div>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-400 hover:text-white transition bg-white/5 hover:bg-white/10 p-2 rounded-full"
                aria-label="Close payment plan"
              >
                <X size={24} aria-hidden="true" />
              </button>
            </div>

            <div className="p-6 overflow-y-auto custom-scrollbar">
              <div className="mb-6 bg-cyan-500/10 border border-cyan-500/30 rounded-lg p-4 text-sm text-cyan-200">
                <p className="font-bold mb-1">Terms &amp; Conditions:</p>
                <ul className="list-disc list-inside space-y-1 opacity-90">
                  <li>Final 10% will be paid on possession.</li>
                  <li>A 5% discount on full cash payment at the time of booking.</li>
                  <li>All payments to be made through cheque/pay order payable to Chaker Ventures.</li>
                  <li>Prices are subject to change without any prior notice.</li>
                  <li>One parking spot will be assigned to each office in the basement parking (First-come, first-served).</li>
                  <li>All corner units will be charged additional 10% of above given prices.</li>
                </ul>
              </div>

              {floorPlans.map((plan, idx) => (
                <div key={idx} className="mb-8">
                  <h4 className="text-xl font-bold text-cyan-400 mb-4 flex items-center gap-2">
                    <Building size={20} aria-hidden="true" />
                    {plan.floor}
                  </h4>
                  <div className="overflow-x-auto">
                    <table className="w-full text-left text-sm text-gray-300">
                      <thead className="bg-[#0d224a] text-cyan-400 uppercase text-xs">
                        <tr>
                          <th className="px-4 py-3 rounded-tl-lg">Office #</th>
                          <th className="px-4 py-3">Area (SqFt)</th>
                          <th className="px-4 py-3">Price/SqFt</th>
                          <th className="px-4 py-3">Total Amount</th>
                          <th className="px-4 py-3">Booking at 60%</th>
                          <th className="px-4 py-3 rounded-tr-lg">2 Monthly Installments</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-cyan-500/10">
                        {plan.offices.map((office, oIdx) => (
                          <tr key={oIdx} className="hover:bg-cyan-500/5 transition">
                            <td className="px-4 py-3 font-semibold text-white">{office.num}</td>
                            <td className="px-4 py-3">{office.area}</td>
                            <td className="px-4 py-3">{office.price.toLocaleString()}</td>
                            <td className="px-4 py-3">{office.total}</td>
                            <td className="px-4 py-3 text-cyan-300">{office.booking}</td>
                            <td className="px-4 py-3">{office.install}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>

            <div className="p-6 border-t border-cyan-500/20 bg-[#0d224a] flex flex-col sm:flex-row justify-between items-center gap-4">
              <p className="text-sm text-gray-400">
                Prices are subject to change. Today's exchange rate will be applied.
              </p>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-cyan-500 hover:bg-cyan-400 text-[#0A1A3A] px-6 py-3 rounded-full font-bold transition flex items-center gap-2 whitespace-nowrap"
                aria-label="Book Citadel 7 office via WhatsApp"
              >
                <Phone size={18} aria-hidden="true" />
                Book via WhatsApp
              </a>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #0A1A3A;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #06b6d4;
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #22d3ee;
        }
      `}</style>
    </div>
  );
};

export default Citadel7;